<template>
    <div class="paper_config">
        <div class="config_title my-10">纸张大小</div>
        <el-radio v-model="paperConfig.paperSize" label="A4">A4纸</el-radio>
        <div class="config_title my-10">试卷样式</div>
        <el-checkbox-group v-model="paperConfig.paperStyleSelectList">
            <el-checkbox v-for="(item, index) in paperStyleList" :label="item.label" :key="index"></el-checkbox>
        </el-checkbox-group>
        <div class="config_title my-10">试卷内容</div>
        <div class="my-5 config_sub_title"><span class="red_xing">*</span> 是否需附答案解析</div>
        <el-radio-group v-model="paperConfig.answerShow">
            <el-radio :label="true">需要</el-radio>
            <el-radio :label="false">无需</el-radio>
        </el-radio-group>
        <div class="my-5 config_sub_title"><span class="red_xing">*</span> 附加位置</div>
        <el-radio-group v-model="paperConfig.answerPosition">
            <el-radio :label="1">题后</el-radio>
            <el-radio :label="2">卷后</el-radio>
        </el-radio-group>
        <div class="my-5 config_sub_title"><span class="red_xing">*</span> 附加内容</div>
        <el-checkbox-group v-model="paperConfig.additionalSelectList">
            <el-checkbox v-for="(item, index) in additionalList" :label="item.label" :key="index"></el-checkbox>
        </el-checkbox-group>
        <template v-if="hasAudio">
            <div class="my-5 config_sub_title">
                <span class="red_xing">*</span> 音频下载方式
            </div>
            <el-radio class="mb-20" v-model="paperConfig.audioDownload" :label="1">
                按试题逐条下载
            </el-radio>
        </template>
        <div class="pay_box flex p-20 mb-20" v-if="examinationInfo.feeType == 2 && !examinationInfo.isBuy && !hasPaid">
            <!-- 二维码区域：有值才显示 -->
            <qrcode-vue :value="qrCodeValue" :size="126" v-if="paperConfig.payType == 1 && qrCodeValue"></qrcode-vue>
            <iframe style="width:130px;height:130px;" :srcdoc="qrCodeValue" scrolling="no"
                v-else-if="paperConfig.payType == 2 && qrCodeValue"></iframe>
            <!-- 如果二维码已隐藏，可以显示支付成功提示 -->
            <div v-else-if="hasPaid" class="pay-success-tip">
                <el-image class="success-icon" :src="iconPath('success_icon.png')"></el-image>
                <div>支付成功</div>
            </div>
            <div class="pay_info ml-30 flex-1 flex flexcolumn FlexBetween">
                <div class="flex FlexBetween Flexalign pay_price">
                    <div>金额：</div>
                    <div class="price_value"><span class="price_unit">￥</span>{{ examinationInfo.price }}</div>
                </div>
                <div class="flex FlexBetween Flexalign pay_price">
                    <div>优惠券：</div>
                    <el-select v-model="paperConfig.couponSelected" placeholder="请选择优惠券" style="width: 150px;">
                        <el-option v-for="item in couponList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex FlexBetween Flexalign pay_price">
                    <div>支付方式：</div>
                    <el-select v-model="paperConfig.payType" placeholder="请选择支付方式" style="width: 150px;"
                        @change="changePayType">
                        <el-option v-for="item in payOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="mb-15 mt-10" v-else>
            <el-button type="primary" @click="downloadAsPDF">下载试卷(PDF)</el-button>
            <el-button type="primary" @click="downloadAsCardPDF">下载答题卡(PDF)</el-button>
            <el-button v-if="hasAudio" type="success" @click="downloadPaperWithAudio">
                下载试卷(含音频)
            </el-button>
        </div>
    </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
    name: 'GjkcH5PaperDownloadConig',
    components: {
        QrcodeVue
    },

    props: {
        examinationInfo: {
            type: Object,
            default: () => ({})
        },
        // 新增：接收试卷内容，用于判断是否有音频
        paperInfo: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            paperStyleList: [
                { label: '密封线', value: 1 },
                { label: '大题评分区', value: 2 },
                { label: '注意事项', value: 3 },
                { label: '考试时间', value: 4 },
                { label: '考生填写', value: 5 },
                { label: '总评分', value: 6 },
                // { label: '分卷', value: 7 },
            ],
            additionalList: [
                { label: '试题答案', value: 1 },
                { label: '试题分析', value: 2 },
                { label: '试题解析', value: 3 },
            ],
            paperConfig: {
                paperSize: 'A4',
                paperStyleSelectList: [''],
                answerShow: false,
                answerPosition: 1,
                additionalSelectList: [''],
                audioDownload: 1,
                payType: 1,
                couponSelected: ''
            },
            qrCodeValue: "",
            payOptions: [
                { label: '微信', value: 1 },
                { label: '支付宝', value: 2 },
            ],
            couponList: [],
            loading: {},
            orderNo: "",
            checkInterval: null, // 定时器
            isChecking: false,    // 是否正在查询
            hasPaid: false,       // 是否已支付
        };
    },
    computed: {
        // 判断试卷是否有音频
        hasAudio() {
            if (!this.paperInfo || !this.paperInfo.paperContext) {
                return false;
            }

            // 遍历所有题目，检查是否有音频
            for (const section of this.paperInfo.paperContext) {
                for (const question of section.questions) {
                    if (this.checkQuestionHasAudio(question)) {
                        return true;
                    }
                }
            }

            return false;
        }
    },

    watch: {
        // 监听配置对象的变化
        paperConfig: {
            handler() {
                // 每当配置变化时，通知父组件
                this.$emit('config-change', this.paperConfig);
            },
            deep: true, // 深度监听，因为paperConfig是对象
            immediate: true // 立即执行一次，传递初始值
        }
    },

    mounted() {
        if (this.examinationInfo.feeType == 2 && !this.examinationInfo.isBuy) {
            this.placeOrder();
        }
    },
    // 组件销毁时清理定时器
    beforeUnmount() {
        this.clearCheckInterval();
    },

    methods: {
        // 检查单个题目是否有音频
        checkQuestionHasAudio(question) {
            if (!question.otherRule) return false;

            try {
                const ruleInfo = JSON.parse(question.otherRule);
                if (ruleInfo?.listeningRule?.audioUrl) {
                    return true;
                }

                // 检查子题
                if (question.questionContext?.subQuestions?.length) {
                    for (const subQ of question.questionContext.subQuestions) {
                        if (this.checkQuestionHasAudio(subQ)) {
                            return true;
                        }
                    }
                }
            } catch (e) {
                console.error('解析音频信息失败:', e);
            }

            return false;
        },
        downloadAsPDF() {
            this.$emit('downloadAsPDF');
        },
        downloadAsCardPDF() {
            this.$emit('downloadAsCardPDF');
        },
        downloadPaperWithAudio() {
            this.$emit('downloadPaperWithAudio');
        },
        // 切换支付方式
        changePayType() {
            this.placeOrder();
        },
        // 下单
        placeOrder() {
            this.loading = this.$loading({
                lock: true,
                text: `正在生成订单`,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$Api.examination
                .placePaperOrder(this.examinationInfo.paperDocumentId)
                .then((res) => {
                    this.orderId = res.data.data.orderId;
                    this.orderNo = res.data.data.orderNo;
                    this.payOrder(this.orderId);

                    // 重置支付状态
                    this.hasPaid = false;

                    // 下单成功后开始定时查询支付状态
                    this.startCheckPayment();
                }).catch(() => {
                    this.loading.close();
                })
        },

        // 开始查询支付状态
        startCheckPayment() {
            // 先清除之前的定时器
            this.clearCheckInterval();

            // 设置新的定时器，每3秒查询一次
            this.checkInterval = setInterval(() => {
                this.checkIsPay();
            }, 3000);

            console.log('开始定时查询订单支付状态');
        },

        // 清除定时器
        clearCheckInterval() {
            if (this.checkInterval) {
                clearInterval(this.checkInterval);
                this.checkInterval = null;
                console.log('定时查询已停止');
            }
        },

        // 检查是否支付
        checkIsPay() {
            // 如果已经支付过，不再重复查询
            if (this.hasPaid || this.isChecking || !this.orderNo) {
                return;
            }

            this.isChecking = true;

            this.$Api.examination
                .checkPaperOrderIspay(this.orderNo)
                .then((res) => {
                    if (res.data.data == true) {
                        // 支付成功
                        this.hasPaid = true;

                        // 停止定时查询
                        this.clearCheckInterval();

                        // 关闭loading
                        if (this.loading && this.loading.close) {
                            this.loading.close();
                        }

                        // 隐藏二维码区域（如果有的话）
                        this.hideQrcode();

                        // 通知父组件（examPaperView）刷新试卷信息
                        this.$emit('order-paid', {
                            paperDocumentId: this.examinationInfo.paperDocumentId,
                            orderId: this.orderId,
                            orderNo: this.orderNo
                        });

                        this.$message.success('支付成功');
                    }
                })
                .catch((error) => {
                    console.error('查询支付状态失败:', error);
                })
                .finally(() => {
                    this.isChecking = false;
                });
        },

        // 隐藏二维码区域
        hideQrcode() {
            // 可以清空二维码值，或者隐藏整个支付区域
            this.qrCodeValue = "";
            // 或者触发视图更新
            this.$forceUpdate();
        },

        // 支付
        payOrder(orderParentId) {
            this.$Api.examination
                .getPaperOrderQrcode({
                    orderPayType: this.paperConfig.payType,
                    orderId: orderParentId,
                    qrcodeWidth: 130,
                })
                .then((res) => {
                    this.loading.close();
                    this.qrCodeValue = res.data.data;

                    // 如果二维码生成成功，确保正在查询支付状态
                    if (!this.checkInterval && this.orderNo) {
                        this.startCheckPayment();
                    }
                }).catch(() => {
                    this.loading.close();
                })
        },

        // 重新生成二维码（如果需要重新支付）
        regenerateQrcode() {
            if (this.orderId) {
                this.payOrder(this.orderId);
                this.startCheckPayment();
            }
        },

        // 手动触发支付查询（供父组件调用）
        manualCheckPayment() {
            if (this.orderNo && !this.hasPaid) {
                this.checkIsPay();
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.paper_config {
    .config_title {
        color: #303030;
        font-size: 16px;
    }

    .config_sub_title {
        font-size: 14px;
        color: #303030;

        .red_xing {
            color: #FE0000;
        }
    }

    .pay_box {
        background: #F7F7F7;
        border-radius: 8px;
        width: 100%;

        .pay_info {
            height: 130px;

            .pay_price {
                font-size: 14px;
                color: #101010;

                .price_value {
                    font-size: 20px;
                    color: #FF7924;
                }

                .price_unit {
                    font-size: 14px;
                }
            }
        }
    }
}
</style>